import React from 'react';

import { t } from '../../../../modules/infra/i18n';
import Date from '../../../common/date';
import { formatAmount } from '../../../common/money';

export default () => [
  {
    Header: t('products:reports.valuation.date_header'),
    accessor: 'date',
    className: 'u-text-left',
    Cell: ({ value }) => <Date>{value}</Date>,
  },
  {
    Header: t('products:reports.valuation.retail_value_header'),
    accessor: 'retailValuation',
    Cell: ({ value }) => (value === null ? t('products:reports.not_available') : formatAmount(value)),
  },
  {
    Header: t('products:reports.valuation.wholesale_supply_value_header'),
    accessor: 'supplyValuation',
    Cell: ({ value }) => (value === null ? t('products:reports.not_available') : formatAmount(value)),
  },
];
